import {useParams} from "react-router";
import ErrorAlert from "../../components/ErrorAlert";
import {notPermitted} from "../../errors";
import MultipleGuard from "../../components/guards/MultipleGuard";
import {permissions} from "../../permissions";
import TableSchedulers from "../../components/schedulers/table/TableSchedulers";

export default function PageAufgabeScheduler() {
    const {aufgabeId = ""} = useParams<{ aufgabeId: string; }>();

    return (
        <MultipleGuard
            permissions={[
                permissions.schedulers.list,
                permissions.schedulers.own_list,
                permissions.schedulers.show,
                permissions.schedulers.own_show,
            ]}
            fallback={<ErrorAlert error={notPermitted()}/>}
        >
            <TableSchedulers aufgabeId={aufgabeId} embedded={true}/>
        </MultipleGuard>
    );
}
